import React from 'react';
import { SignIn } from '@thd-olt-component-react/sign-in';
import { string } from 'prop-types';

const RecentOrderNoAuth = ({ customerName, customerEmail }) => {
  return <SignIn customerName={customerName} customerEmail={customerEmail} />;
};

RecentOrderNoAuth.propTypes = {
  customerName: string,
  customerEmail: string,
};

RecentOrderNoAuth.defaultProps = {
  customerName: null,
  customerEmail: null,
};

export { RecentOrderNoAuth };